import { useContext } from 'react';
import { ToastContext, ToastContextType } from '@contexts/toast-context';

export const useToast = (): ToastContextType => useContext(ToastContext);
